import { render, staticRenderFns } from "./dialogAccreditTo2.vue?vue&type=template&id=4579c8e1&scoped=true&"
import script from "./dialogAccreditTo2.vue?vue&type=script&lang=js&"
export * from "./dialogAccreditTo2.vue?vue&type=script&lang=js&"
import style0 from "./dialogAccreditTo2.vue?vue&type=style&index=0&id=4579c8e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4579c8e1",
  null
  
)

export default component.exports